const { CUSTOM_GTM_ID, CUSTOM_SECOND_GTM_ID, CUSTOM_SERVER_GTM_ID } = process.env;
const SERVER_GTM_ID = CUSTOM_SERVER_GTM_ID ?? 'G-GL0MWXZRS2'; // кастомный id серверного gtm или id проекта Альфабанка

const GTM_ID_CONFIG = {
    'alfabank.ru': CUSTOM_GTM_ID ?? 'GTM-MS8K9L', // кастомный id или id проекта Альфабанка,
    'alfabank.com': CUSTOM_SECOND_GTM_ID ?? 'GTM-WVFQWGZB' // кастомный второй id или второй id проекта Альфабанка на альтернативном домене (alfabank.com)
};

const getGTMId = host => GTM_ID_CONFIG[host] ?? GTM_ID_CONFIG['alfabank.ru'];

const serverGtm = `
    <script async src="https://gtm.alfabank.ru/gtag/js?id=${SERVER_GTM_ID}"></script>
    <script>
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    
        gtag('config', '${SERVER_GTM_ID}', {
    transport_url: 'https://gtm.alfabank.ru',
    first_party_collection: true
    });
   </script>
`;

const gtm = gtmId => `<script>
	(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
	new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
	j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
	'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	})(window,document,'script','dataLayer','${gtmId}');
</script>`;

const gtmNoScript = gtmId => `<noscript>
    <iframe src="//www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0"
        style="display:none;visibility:hidden"></iframe>
    </noscript>`;

module.exports = {
    getGTMId,
    gtm,
    gtmNoScript,
    serverGtm
};
